import PropTypes from "prop-types";
import styles from "./PromoTileWrapper.css";
import mainStyles from "../../Results.css";
import productTileStyles from "../../../ProductTile/ProductTile.css";
import classNames from "classnames";
import PromoTileLink from "./PromoTileLink";

const PromoTileWrapper = ({ linkUrl, children, className }) => (
  <article
    id="promoTile"
    className={classNames(
      styles.promoTileWrapper,
      productTileStyles.productTile,
      className
    )}
  >
    <div>
      <div className={mainStyles.skeletonProductImage} />
      <div className={mainStyles.skeletonTextOne} />
      <div className={mainStyles.skeletonTextTwo} />
      <div className={mainStyles.skeletonTextThree} />
    </div>

    <PromoTileLink linkUrl={linkUrl}>{children}</PromoTileLink>
  </article>
);
PromoTileWrapper.propTypes = {
  storeCode: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default PromoTileWrapper;
